const formatResultDate = (dateString) => {
  const date = new Date(dateString);
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;
  return `${month}/${day}, ${String(hours).padStart(2, "0")}:${minutes} ${ampm}`;
};

const Card32Result = ({ resultData = [] }) => {

  const getCardImage = (card) => {
    if (!card) return "";

    return `/assets/images/cards/${card}.svg`;
  };

  return (
    <div className="left-content" style={{ marginLeft: "5px", marginRight: "3px" }}>

      {resultData.map((row, index) => {

        const cards = row.cards_desc
          ? row.cards_desc.split(",")
          : [];

        const players = [
          {
            label: row.cat_rnr1 || "Player 8",
            card: cards[0],
            winner: String(row.result) === "1"
          },
          {
            label: row.cat_rnr2 || "Player 9",
            card: cards[1],
            winner: String(row.result) === "2"
          },
          {
            label: row.cat_rnr3 || "Player 10",
            card: cards[2],
            winner: String(row.result) === "3"
          },
          {
            label: row.cat_rnr4 || "Player 11",
            card: cards[3],
            winner: String(row.result) === "4"
          }
        ];

        return (

          <div
            key={index}
            className="card"
            style={{
              border: "1px solid #ccc",
              borderRadius: "10px",
              padding: "12px",
              marginBottom: "10px",
              background:
                "linear-gradient(rgb(15,15,15), rgb(251,251,251))"
            }}
          >

            <div
              style={{
                fontWeight: "bold",
                fontSize: "16px",
                marginBottom: "5px",
                marginTop: "7px",
                marginLeft: "7px",
                color: "#fff"
              }}
            >
              {formatResultDate(row.evt_od)} - <b>ID=</b> {row._id}
            </div>

            <hr
              style={{
                borderColor: "#444",
                marginTop: 0,
                marginBottom: "10px"
              }}
            />

            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "2px",
                width: "100%",
                boxSizing: "border-box"
              }}
            >

              {players.map((player, i) => (

                <div
                  key={i}
                  style={{
                    flex: i === 3
                      ? "0 0 100%"
                      : "0 0 calc((100% - 4px) / 3)",

                    width: i === 3
                      ? "100%"
                      : "calc((100% - 4px) / 3)",

                    minWidth: 0,

                    borderRadius: "12px",
                    overflow: "hidden",
                    boxSizing: "border-box",

                    background: player.winner
                      ? "green"
                      : "linear-gradient(#555,#222)"
                  }}
                >

                  <div
                    style={{
                      textAlign: "center",
                      color: "#fff",
                      fontWeight: "bold",
                      fontSize: "16px"
                    }}
                  >
                    {player.label}
                  </div>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      minHeight: "64px"
                    }}
                  >

                    {player.card && (

                      <img
                        src={getCardImage(player.card)}
                        alt=""
                        draggable={false}
                        style={{
                          width: "43px"
                        }}
                      />

                    )}

                  </div>

                  <div
                    style={{
                      background: player.winner
                        ? "#d38f2d"
                        : "#d63d3d",
                      color: "#000",
                      textAlign: "center",
                      fontWeight: "bold",
                      fontSize: "16px",
                      borderRadius: "10px"
                    }}
                  >
                    {player.winner
                      ? "WINNER"
                      : "LOSER"}
                  </div>

                </div>

              ))}

            </div>

          </div>

        );

      })}

    </div>
  );
};

export default Card32Result;